/**
 * @generated SignedSource<<92b1e36104bdb10ec138978d68439c0f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectSettingsViewQuery$variables = {
  tql: string;
  workspaceUuid: string;
};
export type ProjectSettingsViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSettings">;
};
export type ProjectSettingsViewQuery = {
  response: ProjectSettingsViewQuery$data;
  variables: ProjectSettingsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v2 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectSettingsViewQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "tql",
            "variableName": "tql"
          },
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ProjectSettings"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectSettingsViewQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "tql"
          },
          (v2/*: any*/)
        ],
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "description"
                              }
                            ],
                            "type": "CustomFieldDefinitionNode",
                            "abstractKey": "__isCustomFieldDefinitionNode"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/)
                            ],
                            "type": "UserCustomFieldDefinition"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              {
                                "concreteType": "CustomFieldTextAllowedValueConnection",
                                "kind": "LinkedField",
                                "name": "allowedValues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "value"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "TextSelectCustomFieldDefinition"
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "type": "CustomFieldDefinition",
                        "abstractKey": "__isCustomFieldDefinition"
                      }
                    ],
                    "type": "CustomFieldDefinitionNode",
                    "abstractKey": "__isCustomFieldDefinitionNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": "connectionId",
                "kind": "ScalarField",
                "name": "__id"
              },
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SupportedCustomFields",
        "kind": "LinkedField",
        "name": "supportedCustomFields",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldTypeConfig",
            "kind": "LinkedField",
            "name": "typesConfig",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canSetAllowedValues"
              }
            ]
          }
        ]
      },
      {
        "alias": "totalCustomFieldDefinitions",
        "args": [
          {
            "kind": "Literal",
            "name": "q",
            "value": ""
          },
          (v2/*: any*/)
        ],
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "count"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4439e70eafa756b363f1a7fb2cee2b36",
    "id": null,
    "metadata": {},
    "name": "ProjectSettingsViewQuery",
    "operationKind": "query",
    "text": "query ProjectSettingsViewQuery(\n  $workspaceUuid: UUID!\n  $tql: String!\n) {\n  ...ProjectSettings_Z4eZt\n}\n\nfragment CreateCustomFieldForm on SupportedCustomFields {\n  ...CustomFieldForm\n}\n\nfragment CustomFieldBaseRow on CustomFieldDefinition {\n  __isCustomFieldDefinition: __typename\n  __typename\n  ... on CustomFieldDefinitionNode {\n    __isCustomFieldDefinitionNode: __typename\n    id\n    name\n    type\n    description\n  }\n  ... on UserCustomFieldDefinition {\n    canSetMultipleValues\n  }\n  ... on TextSelectCustomFieldDefinition {\n    canSetMultipleValues\n    allowedValues {\n      edges {\n        node {\n          id\n          value\n        }\n      }\n    }\n  }\n}\n\nfragment CustomFieldDefinitionRow on CustomFieldDefinition {\n  __isCustomFieldDefinition: __typename\n  ... on CustomFieldDefinitionNode {\n    __isCustomFieldDefinitionNode: __typename\n    id\n  }\n  ...CustomFieldBaseRow\n  ... on Node {\n    __isNode: __typename\n    id\n  }\n}\n\nfragment CustomFieldForm on SupportedCustomFields {\n  typesConfig {\n    type\n    canSetMultipleValues\n    canSetAllowedValues\n  }\n}\n\nfragment CustomFieldList on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on CustomFieldDefinitionNode {\n        __isCustomFieldDefinitionNode: __typename\n        id\n        ...CustomFieldDefinitionRow\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment EditCustomFieldForm on SupportedCustomFields {\n  ...CustomFieldForm\n}\n\nfragment ProjectSettings_Z4eZt on Query {\n  ...TabPanelBody_Z4eZt\n  totalCustomFieldDefinitions: customFieldDefinitionTql(q: \"\", workspaceUuid: $workspaceUuid) {\n    count\n  }\n}\n\nfragment TabPanelBody_Z4eZt on Query {\n  customFieldDefinitionTql(q: $tql, workspaceUuid: $workspaceUuid) {\n    edges {\n      __typename\n    }\n    ...CustomFieldList\n  }\n  supportedCustomFields {\n    ...CreateCustomFieldForm\n    ...EditCustomFieldForm\n  }\n}\n"
  }
};
})();

(node as any).hash = "0aad44a95f13d0ed94a1f2067e14e00c";

export default node;
